import { render, staticRenderFns } from "./SignoffSalesTab.vue?vue&type=template&id=1885b7be&"
import script from "./SignoffSalesTab.vue?vue&type=script&lang=js&"
export * from "./SignoffSalesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports